<template>
  <div class="top-toolbar" data-figma-node="2800:304">
    <a class="back-link" href="https://feltright.com">
      <img class="back-link__icon" src="/new-studio/icons/back-to-site.svg" alt="" aria-hidden="true">
      Back To Site
    </a>
    <nav class="top-toolbar__actions" aria-label="Project tools">
      <div class="top-toolbar__project-actions">
        <NewStudioToolButton label="Preview" icon="/new-studio/icons/preview.svg" :disabled="!hasDesign" @click="actions.preview" />
        <NewStudioToolButton label="New" icon="/new-studio/icons/new.svg" @click="actions.startNew" />
        <NewStudioToolButton label="Load" icon="/new-studio/icons/load.svg" @click="actions.load" />
        <NewStudioToolButton label="Save" icon="/new-studio/icons/save.svg" @click="actions.save" />
        <NewStudioToolButton label="Save As" icon="/new-studio/icons/save-as.svg" @click="actions.saveAs" />
      </div>
      <div class="top-toolbar__account-actions">
        <NewStudioToolButton label="View in Room" multiline icon="/new-studio/icons/view-in-room.svg" :disabled="!hasShapes" @click="actions.viewInRoom" />
        <NewStudioToolButton label="Your Designs" multiline icon="/new-studio/icons/your-designs.svg" @click="actions.yourDesigns" />
        <NewStudioToolButton label="Settings" icon="/new-studio/icons/settings.svg" @click="actions.settings" />
        <NewStudioToolButton label="Share" icon="/new-studio/icons/share.svg" :disabled="!hasDesign" @click="actions.share" />
        <NewStudioToolButton :label="userStore.isLoggedIn ? 'Logout' : 'Login'" icon="/new-studio/icons/login.svg" @click="actions.login" />
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{ viewInRoom: [] }>()
const actions = useNewStudioActions({ onViewInRoom: () => emit('viewInRoom') })
const { hasDesign, hasShapes } = actions
const userStore = useUserStore()
onMounted(() => userStore.initializeFromCookie())
</script>

<style scoped>
.top-toolbar {
  display: flex;
  height: var(--studio-toolbar-height);
  align-items: center;
  justify-content: space-between;
  padding: 11px 22px 12px;
  border-bottom: 1px solid var(--studio-shell-border);
  background: var(--studio-surface);
}

.back-link {
  display: inline-flex;
  padding: 12px 22px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 2px solid #e2e1dc;
  color: var(--studio-text-dark);
  font-size: 15px;
  font-weight: var(--studio-font-semibold);
  text-decoration: none;
}

.back-link__icon {
  width: 16px;
  height: 16px;
}

.top-toolbar__actions {
  display: flex;
  align-items: center;
}

.top-toolbar__project-actions,
.top-toolbar__account-actions {
  display: flex;
  align-items: flex-start;
}

.top-toolbar__project-actions :deep(.studio-tool) {
  width: 65px;
  margin-right: -4px;
}

.top-toolbar__project-actions :deep(.studio-tool:last-child),
.top-toolbar__account-actions :deep(.studio-tool:last-child) {
  margin-right: 0;
}

.top-toolbar__account-actions :deep(.studio-tool) {
  width: 75px;
  margin-right: -6px;
}
</style>
